import { Image } from "antd";
import CAGLogo from "assets/CAG_logo.png";

type LogoProps = {
	classes?: string;
};

const Logo = ({ classes }: LogoProps) => {
	return <Image src={CAGLogo} alt="Logo" className={classes} preview={false} />;
};

export default Logo;
